import RequiredField from "../RequiredField";
import InboundLimitTierSetDocument from "./InboundLimitTierSetDocument";

export default class RedemptionLookupResponse {

  constructor(jsonResponse) {
    if (jsonResponse) {
      this.transactionId = jsonResponse["transaction-id"];
      this.collectionPin = jsonResponse["collection-pin"];
      this.transactionType = jsonResponse["transaction-type"];
      this.transactionTypeDisplayValue = jsonResponse["transaction-type-display-value"];
      this.countryFrom = jsonResponse["country-from"];
      this.beneficiaryCurrency = jsonResponse["beneficiary-currency"];
      this.beneficiaryAmount = jsonResponse["beneficiary-amount"];
      this.beneficiaryFirstName = jsonResponse["beneficiary-first-name"];
      this.beneficiaryLastName = jsonResponse["beneficiary-last-name"];
      this.beneficiaryMsisdn = jsonResponse["beneficiary-msisdn"];
      this.customerFirstName = jsonResponse["customer-first-name"];
      this.customerLastName = jsonResponse["customer-last-name"];
      this.senderType = jsonResponse["sender-type"];

      this.requiredFields = [];
      if(jsonResponse["required-fields"]) {
        jsonResponse["required-fields"].forEach(field => {
          this.requiredFields.push(new RequiredField(field));
        })
      }

      this.limitIncreaseRequired = jsonResponse["limit-increase-required"]
      this.requiredDocuments = [];
      if(jsonResponse["required-documents"]) {
        jsonResponse["required-documents"].forEach(field => {
          this.requiredDocuments.push(new InboundLimitTierSetDocument(field));
        })
      }
    }
  }
}
